import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate'

// modules
import auth from "./modules/auth";
import topBar from "./modules/topBar";
import games from "./modules/games";
import recharge from "./modules/recharge";
import withdraw from "./modules/withdraw";
import lang from "./modules/lang";
import sideBar from "./modules/sideBar";
import activity from "./modules/activity";
import spinWheel from "./modules/spinWheel";
import vip from "./modules/vip";
import informationCenter from './modules/informationCenter'
import orderCenter from './modules/orderCenter'
import security from './modules/security'
import advertisement from './modules/advertisement'

Vue.use(Vuex)

let store

const initStore = () =>  { 
  return store || ( store = new Vuex.Store({
    plugins: [createPersistedState({
      key: 'persisted_state',
      paths: [
        
      ],
    })],
    modules: {
      auth, 
      topBar, 
      games, 
      recharge, 
      withdraw, 
      lang, 
      sideBar, 
      activity, 
      spinWheel, 
      vip, 
      informationCenter,
      orderCenter,
      security,
      advertisement
    },
  }))
}

export default initStore


// WEBPACK FOOTER //
// ./src/vuex/store.js